import { CompanyMyRemunerationContent } from "../../features/companyWorkspace";

function CompanyMyRemunerationScreen() {
  return <CompanyMyRemunerationContent />;
}

export default CompanyMyRemunerationScreen;
